import {
  ControlledCheckbox,
  ControlledTextField
} from 'components/shared/ControlledFields';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

const FormContent = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <Grid width="500px" container direction={'column'} spacing={2.5}>
      <Grid item>
        <ControlledTextField
          control={control}
          label={t('dutyExchange.durationDifference')}
          name="duty_duration_difference"
        />
      </Grid>
      <Grid item>
        <ControlledCheckbox
          control={control}
          name={'preferred_function_match'}
          label={t('dutyExchange.allowExchange')}
        />
      </Grid>
    </Grid>
  );
};

export default FormContent;
